export default {
  // baseURL: "https://api.i-dealhomeonline.com/admin",
  baseURL: "https://api-dev.i-dealhomeonline.com/admin",
  // baseURL: "http://localhost:5000/admin",
  aws: {
    accessKeyId: 'AKIATOQMWBSZGUVT4SHV',
    secretKeyId: 'QK+f9lnXYKkSCCyavBjDClBhEOl2jh/+GZ1BcnK/',
  }
}